/* eslint-disable @angular-eslint/directive-selector */
import { Directive, OnDestroy, HostListener, ElementRef } from '@angular/core';

@Directive({ selector: '[kendoPopupAutoResize]' })
export class KendoPopupAutoResizeDirective implements OnDestroy {
  private readonly observer: MutationObserver;

  constructor(private readonly el: ElementRef) {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of Array.from(mutation.addedNodes)) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.classList.contains('k-animation-container')) {
            const foundElement = this.findPopupElement(node);
            if (foundElement) {
              requestAnimationFrame(() => {
                this.adjustKendoPopup(foundElement);
                setTimeout(() => this.adjustKendoPopup(foundElement), 200);
              });
              break;
            }
          }
        }
      }
    });

    const parent = this.el.nativeElement;
    this.observer.observe(parent, { childList: true, subtree: true });
  }

  @HostListener('window:resize')
  onWindowResize() {
    const popupElement = document.querySelector<HTMLElement>(
      '.k-popup.k-multiselecttree-popup',
    );
    this.adjustKendoPopup(popupElement);
  }

  private adjustKendoPopup(popupElement: HTMLElement | null) {
    if (popupElement) {
      const rect = popupElement.getBoundingClientRect();
      const availableSpaceBelow = window.innerHeight - rect.top;

      popupElement.style.maxHeight = `${availableSpaceBelow - 20}px`;
      popupElement.style.overflowY = 'auto';
    }
  }

  private findPopupElement(node: Node): HTMLElement | null {
    if (
      node instanceof HTMLElement &&
      node.classList.contains('k-popup') &&
      node.classList.contains('k-multiselecttree-popup')
    ) {
      return node;
    }

    for (const childNode of Array.from(node.childNodes)) {
      const foundNode = this.findPopupElement(childNode);
      if (foundNode) {
        return foundNode;
      }
    }

    return null;
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
